import React, { useState, useEffect, useContext } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
  excelMapping,
  ExportToExcel,
  getDiviceInfo,
  inWords,
} from "../../utils/utilFuctions";
import {
  BASE_URL_API_TRANXT,
  BASE_URL_API_TRANXT_API,
  BASE_URL_APISERVICES,
} from "../../utils/Constants";
import { CLIENT } from "../../config";
import { GlobalContext } from "../../Context/GlobalState";
import swal from "sweetalert";
import { offsetArr } from "../../utils/CommonConfig";
import {
  CERTIFICATE_ADDRESS,
  CERTIFICATE_COMPANY_NAME,
  COMPANY_NAME,
} from "../../utils/StringConstants";
import { get } from "react-hook-form";

const months = [
  "Jan",
  "Feb",
  "March",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const dateFormatToDisplay = (date) => {
  if (date) {
    const d = new Date(date);

    let hours = d.getHours();
    let minutes = d.getMinutes();
    let ap = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes.toString().padStart(2, "0");
    let mergeTime = hours + ":" + minutes + " " + ap;
    return `${d.getDate()} ${
      months[d.getMonth()]
    } ${d.getFullYear()} ${mergeTime}`;
  } else {
    return "";
  }
};

const paymentModes = {
  3: "Cash Deposite",
  2: "UPI/IMPS",
  5: "NEFT/RTGS",
  9: "CDM",
  8: "Fund Transfer",
  9: "CHEQUE",
};

// const paymentModes =
//   {
//     3: "Cash Deposite",
//     2: "UPI/IMPS",
//     5: "NEFT/RTGS",
//     9: "CDM",
//     8: "Fund Transfer",
//     9: "CHEQUE",
//   },
// ];

const columns = [
  // {
  //   dataField: "S_No",
  //   text: "S No.",
  //   sort: false,
  // },
  {
    dataField: "agent_id",
    text: "User ID",
    sort: false,
  },
  {
    dataField: "utr",
    text: "UTR",
    sort: false,
  },
  {
    dataField: "virtual_account",
    text: "REF ID",
    sort: false,
  },
  {
    dataField: "amount",
    text: "Amount",
    sort: false,
  },

  {
    dataField: "sender_account_no",
    text: "Sender AC NO.",
    sort: false,
  },
  {
    dataField: "sender_account_name",
    text: "Sender Name",
    sort: false,
  },
  {
    dataField: "sender_account_ifsc",
    text: "Sender IFSC",
    sort: false,
  },
  {
    dataField: "date",
    text: "Date & Time",
    sort: false,
  },
  {
    dataField: "refrence_no",
    text: "REF",
    sort: false,
  },

  {
    dataField: "status",
    text: "Status",
    sort: false,
  },
  {
    dataField: "remarks",
    text: "remarks",
    sort: false,
  },
  // {
  //   dataField: "UpdateDate",
  //   text: "Update Date",
  //   sort: false,
  // },
];

const VirtualReportTable = () => {
  const initialState = {
    remark: "",
   
  };
    const [state, setState] = useState(initialState);
  
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [mdShow, setMdShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [offset, setOffset] = useState(10);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [startDate, setStartDate] = useState(getDatePreviousMonth());
  const [endDate, setEndDate] = useState(new Date());
  const { user, Profileinfo } = useContext(GlobalContext);
  console.log(user);

  const [ledger, setLedger] = useState([]);

  function getDatePreviousMonth(date = new Date()) {
    date.setMonth(date.getMonth() - 1);
    return date;
  }
  const dateFormatter = (date) => {
    return `${date.getFullYear()}-${
      date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
    }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  const openInNewTab = (data) => {
    localStorage.setItem(
      "print",
      JSON.stringify({ ...data, shopName: Profileinfo.shopname })
    );
    const newWindow = window.open(
      `/pages/aeps_print?id=${data.tid}&type=AEPS`,
      "",
      "height=600,width=800'"
    );
    if (newWindow) newWindow.opener = null;
  };

  useEffect(() => {
    let filteredData = data.filter((bank) => {
      let b = false;
      if (data.length > 0) {
        for (let key in data[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
    setTotal(filteredData.length);
    const startIdx = 0;
    const endIdx = offset - 1;
    filteredData = filteredData.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    setCurrentPage(1);
  }, [searchText]);

  useEffect(() => {
    let filteredData = data.filter((bank) => {
      let b = false;
      if (data.length > 0) {
        for (let key in data[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    console.log(filteredData);
    const startIdx = (currentPage - 1) * offset;
    const endIdx = currentPage * offset - 1;
    console.log({ startIdx, endIdx });
    filteredData = filteredData.filter((bank, idx) => {
      console.log(idx, idx <= endIdx && idx >= startIdx);
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    console.log({ startIdx, endIdx });
  }, [currentPage]);

  // did mount
  useEffect(() => {
    setPages(Math.floor((data.length + (offset - 1)) / offset));
    const startIdx = 0;
    const endIdx = offset - 1;
    setTotal(data.length);
    console.log(startIdx);
    console.log(data);
    const filteredData = data.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    console.log(filteredData);
    setDataToDisplay(filteredData);
  }, [data, offset]);

  const dateToStr = (date) =>
    `${date.getFullYear()}-${
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1
    }-${date.getDate()}`;

  const now = (date = new Date()) => {
    return `${date.getFullYear()}-${
      date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
    }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };

  const getVirtualPaymentReport = () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        fromdate: dateFormatter(startDate),
        todate: dateFormatter(endDate),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `https://apiservices.bumppypay.com/api/Payment/admin/getAllVirtualTransactions`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.responseCode == "00") {
            setData(data.data);
          } else {
            setData([]);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {}
  };

  const acceptPopup = async (referenceID) => {
    swal("Write Remark", {
      content: "input",
    }).then((text) => {
      acceptVirtualPayment(referenceID, text);
    });
  };

  const acceptVirtualPayment = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic Tm9Nb3JlT3duZXJOYW1lQGJ1bXBweS5jb206SEpwZG1GMFpTQnpkR0YwYVdNZ1ptbHVZV3dnVTNSeWFXNW4="
      );
      myHeaders.append("Content-Type", "application/json");

      const deviceData = getDiviceInfo();

      var raw = JSON.stringify({
        userid: user.ReferId,
        refId: selectedRow.refrence_no,
        status: "ACCEPT",
        remarks: state.remark,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${BASE_URL_APISERVICES}/api/Virtual/v1.0/acceptVirtualPayment`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.responseCode == "00") {
            swal("Success", data.responseMessage, "success");
          } else {
            swal("Failed", data.responseMessage, "error");
          }
          getVirtualPaymentReport();
          setMdShow(false);
        })
        .catch((error) => console.log("error", error));
    } catch (error) {}
  };

  useEffect(() => {
    getVirtualPaymentReport();
  }, []);
  console.log(ledger);
  return (
    <>
      <Modal
        show={mdShow}
        onHide={() => setMdShow(false)}
        aria-labelledby="example-modal-sizes-title-md"
        size="lg"
      >
        <Modal.Body
          style={{ width: "100%", height: "100vh", display: "block" }}
          className="account"
        >
          {Profileinfo && (
            <Row>
              <div style={{ width: "100%" }}>
                <div style={{ textAlign: "center" }}>
                  <h3>INDEMNITY BOND</h3>
                </div>
                <div className="card-body">
                  <div className="d-flex"></div>

                  <div className="row d-flex mt-2">
                    <div className="col-6">
                      <h5>
                        <strong>Date:- </strong> {dateFormatToDisplay()}
                      </h5>
                      <h5>
                        <strong>From:- </strong>
                      </h5>
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                      <img
                        src={require("../../../assets/images/company/navbar_logo.png")}
                        style={{
                          width: "60%",
                          height: "auto",
                          marginLeft: "auto",
                        }}
                      />
                    </div>
                  </div>

                  <table style={{ border: "1px solid black", width: "100%" }}>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Merchant/Agent name</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {Profileinfo?.shopname}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>BC Agent Id</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {user?.ReferId}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Registered Mobile number</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {Profileinfo?.mobile}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>PAN number</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {selectedRow?.pan}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Request No.</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        18012023419638
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Amount</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        Rs. {selectedRow.amount}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Amount (In Words)</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {inWords(Number(selectedRow.amount))}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Bank Account </strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {selectedRow?.bankName} -: {selectedRow?.accountNo}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Deposit Date</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {dateFormatToDisplay(selectedRow.date)}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Payment Type</strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {"UPI"}
                      </td>
                    </tr>
                    <tr style={{ background: "white" }}>
                      <td style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        <strong>Remark </strong>
                      </td>
                      <td style={{ fontSize: ".9rem", fontWeight: "bold" }}>
                        {selectedRow.remark}
                      </td>
                    </tr>
                  </table>

                  <div className="my-4">
                    <strong>
                      To,<br></br>
                      The Board of Directors,<br></br>
                      {CERTIFICATE_COMPANY_NAME} <br></br>
                      <span>{CERTIFICATE_ADDRESS}</span>
                    </strong>
                  </div>

                  <div>
                    <p className="mb-2" style={{ fontSize: "16px" }}>
                      Dear Sir/Madam,
                    </p>

                    <p style={{ fontSize: "16px" }}>
                      I, <strong>{Profileinfo?.shopname}</strong>, as a
                      Merchant/Agent hereby undertake and explicitly agree to
                      indemnify {CERTIFICATE_COMPANY_NAME} towards the following
                      points:
                    </p>

                    <div className="p-4">
                      <ul style={{ fontSize: "16px" }}>
                        <li>
                          {CERTIFICATE_COMPANY_NAME} is providing us with a
                          platform as an enabler through which we can
                          transfer/receive/top up the money through various
                          methods likeUPI/ IMPS/ RTGS/ Payment Gateway etc. from
                          one person to another(P2P and P2M) against a separate
                          consideration;
                        </li>
                        <li>
                          I am wholly and solely responsible for the collection
                          of KYC/ meeting the Statutory requirements and other
                          mandatory documents from the sender or receiver or
                          both and also the reasons of such transactions;
                        </li>
                        <li>
                          I am responsible and abide to provide the KYC and
                          other mandatory documents and reasons of each and
                          every transactions with end customers to the at{" "}
                          {COMPANY_NAME}'s discretion;
                        </li>
                        <li>
                          I am wholly and solely responsible for those
                          transactions which was wrongly debited or credited by
                          me to another party or any incorrect entry/entries
                          while using the platform;and
                        </li>
                        <li>
                          After obtaining a proper understanding of the
                          transaction patterns of this Company, I am giving my
                          consent to use this platform with all the terms and
                          conditions as provided by the{" "}
                          {CERTIFICATE_COMPANY_NAME} and also assuring that
                          every sender or receiver or both only after giving
                          their full consent using this platform for transfer /
                          receive / topup the money through various methods like
                          CASH / UPI / IMPS / NEFT / RTGS / Payment Gateway etc.
                        </li>
                      </ul>
                    </div>

                    <p className="mt-4" style={{ fontSize: "16px" }}>
                      Thanking you,
                    </p>

                    <p style={{ fontSize: "16px", marginTop: "4rem" }}>
                      <strong>
                        {Profileinfo?.shopname}
                        <br></br>
                        (Merchant’s/Agent’s Name)<br></br>
                        {Profileinfo?.name}
                        <br></br>
                        Seal and Signature<br></br>
                      </strong>
                    </p>

                    <p className="mt-2" style={{ fontSize: "16px" }}>
                      <strong>
                        Timestamp : {dateFormatToDisplay(new Date())}
                      </strong>
                    </p>
                       <div className="row col-12">
                                      <Form.Group>
                                        <Form.Label className="text-dark">
                                          <span style={{ color: "red" }}>*</span>
                                          {`Remark`}
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          className="form-control rounded-lg"
                                          aria-label="Notes"
                                          aria-describedby="basic-addon1"
                                          placeholder="Enter Remark"
                                          value={state.remark}
                                          onChange={(e) => {
                                            setState({ ...state, remark: e.target.value });
                                          }}
                                          style={{ borderRadius: "0px" }}
                                        />
                                      </Form.Group>
                                    
                                  </div>
                    <div className="row">
                      <div className="col-6"></div>
                      <div className="col-12 col-md-6 d-flex justify-content-end">
                        <Button
                          variant="success"
                          className="rounded-0"
                          onClick={acceptVirtualPayment}
                        >
                          Accept
                        </Button>
                        <Button
                          variant="danger"
                          className="rounded-0 mx-2"
                          onClick={() => {
                            setMdShow(false);
                          }}
                        >
                          Decline
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          )}
        </Modal.Body>
      </Modal>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", margin: "10px 0px" }}
        >
          <div className="row">
            <div className="col-12 col-sm-4 col-md-2 p-0">
              <Form.Group>
                <Form.Label> Search in Table</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control rounded-0"
                  aria-label="Notes"
                  aria-describedby="basic-addon1"
                  placeholder="Search"
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  value={searchText}
                />
              </Form.Group>
            </div>
            <div className="col-12 col-sm-4 col-md-2">
              <Form.Group>
                <Form.Label style={{}}> From Date </Form.Label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  className="form-control rounded-0 border-primary"
                  placeholderText="Start Date"
                  style={{ borderRadius: "0px" }}
                />
              </Form.Group>
            </div>
            <div className="col-12 col-sm-4 col-md-2 p-0">
              <Form.Group>
                <Form.Label> To Date </Form.Label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  className="form-control rounded-0 border-primary"
                  placeholderText="end Date"
                  style={{ borderRadius: "0px" }}
                />
              </Form.Group>
            </div>
            <div className="col-12 col-sm-4 col-md-2">
              <FormGroup className="ml-2 mt-4">
                <Button
                  className="m-0 mx-1"
                  type="button"
                  variant="success"
                  style={{ borderRadius: "0px" }}
                  onClick={getVirtualPaymentReport}
                >
                  Search
                </Button>
              </FormGroup>
            </div>
            <div className="col-12 col-sm-4 col mt-4">
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  ExportToExcel(
                    `Virtual_report_${now()}`,
                    excelMapping(data, columns)
                  );
                }}
              >
                <img
                  src={require("../../../assets/images/excel.png")}
                  style={{ width: "1.6rem" }}
                />
                <strong style={{ marginLeft: "4px" }}>Export to Excel</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: "1" }}></div>
        </div>
      </div>
      <div className="scroll-inner fix-width">
        <table
          className="dashboard-table-style"
          style={{ width: "100%", overflowX: "scroll" }}
        >
          <tr>
            <th style={{ fontSize: "0.9rem" }}> {"Sr"}</th>
            {columns.map((heading) => (
              <th className="text-center" style={{ fontSize: "0.9rem" }}>
                {heading.text}
              </th>
            ))}
            <th className="text-center" style={{ fontSize: "0.9rem" }}>
              Action
            </th>
          </tr>
          {dataToDisplay.map((e, ind) => (
            <tr>
              <td style={{ fontSize: "0.8rem" }}> {ind + 10}</td>
              {columns.map((cell) =>
                cell.text == "Acceptance" ? (
                  e[cell.dataField] == "Y" ? (
                    <td style={{ fontSize: "0.8rem" }}>
                      {" "}
                      <label
                        style={{
                          padding: "4px",
                          borderRadius: "4px",
                          minWidth: "4rem",
                        }}
                        className="badge badge-success"
                      >
                        {"Accepted"}
                      </label>{" "}
                    </td>
                  ) : (
                    <td style={{ fontSize: "0.8rem" }}>
                      <Button
                        onClick={() => {
                          // e.va_reference_no
                          acceptPopup(e.va_reference_no);
                        }}
                      >
                        {" "}
                        Accept
                      </Button>
                    </td>
                  )
                ) : (
                  <td style={{ fontSize: ".8rem" }}>{e[cell.dataField]}</td>
                )
              )}
              <td>
                {e.status == "ACCEPTED" ? (
                  <label
                    style={{
                      padding: "4px",
                      borderRadius: "4px",
                      minWidth: "4rem",
                    }}
                    className="badge badge-info"
                  >
                    {"Accepted"}
                  </label>
                ) : (
                  <Button
                    onClick={() => {
                      setSelectedRow(e);
                      setMdShow(true);
                    }}
                    variant="success"
                    className="rounded-0"
                  >
                    {" "}
                    Accept
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </table>
      </div>
      <Pagination
        page={currentPage}
        limit={pages}
        callback={(page) => {
          setCurrentPage(page);
        }}
        count={dataToDisplay.length}
        total={total}
        callback2={(offsetValue) => {
          setOffset(offsetValue);
        }}
      />
    </>
  );
};

const Pagination = ({ page, limit, callback, total, count, callback2 }) => {
  console.table({ page, limit, callback });
  return (
    <div
      className="row"
      style={{
        display: "flex",
        alignItems: "end",
        width: "100%",
        margin: "10px 0px",
        justifyContent: "space-between",
      }}
    >
      <div>
        <strong>{`Showing ${count} of ${total} entries`}</strong>
      </div>
      <div className="d-flex">
        <select
          className="form-control"
          aria-label="offset"
          onChange={(e) => {
            callback2(e.target.value);
          }}
        >
          {offsetArr.map((offset) => (
            <option value={offset}>{offset}</option>
          ))}
        </select>
        {page - 2 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            variant="light"
          >
            {"Previous"}
          </Button>
        ) : null}

        {page - 1 > 0 ? (
          <Button
            onClick={() => {
              callback(page - 1);
            }}
            variant="light"
          >
            {" "}
            {(page - 1).toString()}
          </Button>
        ) : null}
        <Button variant="primary"> {page.toString()}</Button>
        {page + 1 <= limit ? (
          <Button
            onClick={() => {
              callback(page + 1);
            }}
            variant="light"
          >
            {"Next"}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default VirtualReportTable;
